<div
  class="big-title-spotlight-section-wrap"
  [ngClass]="{
    tablet: globalUtilsService.isTablet(),
    mobile: globalUtilsService.isMobile()
  }"
>
<div class="big-title-spotlight-section">

  <div class="h2-container">
    <h2>
      <span class="arrow">></span>
      {{ textTitle }} <span class="musique">Musicais</span>
    </h2>
  </div>

  <h1>
    <div class="first-paragraph paragraph">
      <div class="word">
        <div class="char">D</div>
        <div class="char">E</div>
        <div class="char">S</div>
        <div class="char">C</div>
        <div class="char">U</div>
        <div class="char">B</div>
        <div class="char">R</div>
        <div class="char">A</div>
      </div>
      <br>
      <div class="word colored">
        <div class="char">O</div>
      </div>
      <div class="word colored">
        <div class="char">S</div>
        <div class="char">E</div>
        <div class="char">U</div>
      </div>
      <div class="word colored">
        <div class="char">S</div>
        <div class="char">O</div>
        <div class="char">M</div>
      </div>
      <div class="word underline">_</div>
    </div>

    <div class="second-paragraph paragraph">
      <div class="word">
        <div class="char">D</div>
        <div class="char">E</div>
        <div class="char">S</div>
        <div class="char">C</div>
        <div class="char">U</div>
        <div class="char">B</div>
        <div class="char">R</div>
        <div class="char">A</div>
      </div>
      <br>
      <div class="word colored">
        <div class="char">S</div>
        <div class="char">U</div>
        <div class="char">A</div>
      </div>
      <div class="word colored">
        <div class="char">M</div>
        <div class="char">E</div>
        <div class="char">L</div>
        <div class="char">O</div>
        <div class="char">D</div>
        <div class="char">I</div>
        <div class="char">A</div>
      </div>
      <div class="word underline">_</div>
    </div>

    <div class="third-paragraph paragraph">
      <div class="word">
      <div class="char">D</div>
      <div class="char">E</div>
      <div class="char">S</div>
      <div class="char">C</div>
      <div class="char">U</div>
      <div class="char">B</div>
      <div class="char">R</div>
      <div class="char">A</div>
      </div>
      <div class="word">
      <div class="char">A</div>
      </div>
      <br>
      <div class="word colored">
      <div class="char">S</div>
      <div class="char">O</div>
      <div class="char">N</div>
      <div class="char">O</div>
      <div class="char">R</div>
      <div class="char">A</div>
      </div>
      <div class="word colored">
      <div class="char">M</div>
      <div class="char">U</div>
      <div class="char">S</div>
      <div class="char">I</div>
      <div class="char">C</div>
      <div class="char">A</div>
      <div class="char">L</div>
      </div>
      <div class="word underline">_</div>
    </div>
  </h1>

  <!-- <a class="fazer-simulacao-botao" href="https://simulador.paraisofotovoltaico.com.br/">
    <span>FAZER SIMULAÇÃO</span>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 11.5 12.121"
    >
      <g transform="translate(0.75 1.061)">
        <line
          x2="10"
          transform="translate(0 5)"
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <path
          d="M12,5l5,5-5,5"
          transform="translate(-7 -5)"
          fill="none"
          stroke="#000"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </svg>
  </a> -->
</div>
